import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  button: {
    backgroundColor: "#898989",
    color: "#FFF",
    fontSize: 12,
    height: "auto",
    width: "auto",
    margin: 5,
  },
});

const MiniButton = (props) => {
  const classes = useStyles();
  return (
    <Button className={classes.button} variant="contained" onClick={() => props.onClick()}>
      {props.label}
    </Button>
  );
};
export default MiniButton;
